import type { FunctionComponent } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

import { HoverIcon } from "pro-features/components/core cells/src/CoreAppCell/StyledComponents";

import {
    RecommendationKeywordTileStyled,
    RecommendationKeywordStyled,
    RecommendationKeywordDataStyled,
    RecommendationKeywordDataTitleStyled,
    RecommendationKeywordDataValueStyled,
} from "./StyledComponents";

interface IRecommendationKeywordTileProps {
    keyword: string;
    link: string | undefined;
    volume: string;
    cpc: string;
    onClick: VoidFunction;
    isLoading: boolean;
}

export const RecommendationKeywordTile: FunctionComponent<IRecommendationKeywordTileProps> = (props) => {
    const { keyword, link, volume, cpc, onClick, isLoading = false } = props;
    const { translate } = useTranslate();
    return (
        <RecommendationKeywordTileStyled>
            <RecommendationKeywordStyled>
                <>
                    <span>{keyword}</span>{" "}
                    {link ? (
                        <a
                            href={link}
                            target="_blank"
                        >
                            <HoverIcon iconName="link-out" />
                        </a>
                    ) : null}
                </>
            </RecommendationKeywordStyled>
            <RecommendationKeywordDataStyled>
                <RecommendationKeywordDataTitleStyled>
                    {translate("monitor.keywords.recommendation.sidebar.avg.volume")}
                </RecommendationKeywordDataTitleStyled>
                <RecommendationKeywordDataValueStyled>{volume}</RecommendationKeywordDataValueStyled>
            </RecommendationKeywordDataStyled>
            <RecommendationKeywordDataStyled>
                <RecommendationKeywordDataTitleStyled>
                    {translate("monitor.keywords.recommendation.sidebar.cpc")}
                </RecommendationKeywordDataTitleStyled>
                <RecommendationKeywordDataValueStyled>{cpc}</RecommendationKeywordDataValueStyled>
            </RecommendationKeywordDataStyled>
            <Button
                width={70}
                style={{ minWidth: "70px" }}
                type={isLoading ? "primary" : "outlined"}
                isLoading={isLoading}
                isDisabled={isLoading}
                onClick={onClick}
            >
                {translate("monitor.keywords.recommendation.sidebar.add")}
            </Button>
        </RecommendationKeywordTileStyled>
    );
};
